<template>
	<div class="form-info">
		<button type="button" class="handler" :style="{ top: options.top, left: options.left }" @click.prevent="$emit('toggleDisplayMode')" :title="$t('document.display-mode.toggle-header-mode')">
			<i class="fal fa-right-left" style="font-weight: 500;"></i>
		</button>
	</div>
</template>
<script>

	export default {
		name: 'display-mode-toggler',
		props: {
			data: {},
			options: {}
		},
		emits: ['toggleDisplayMode'],
		data() {
			return {
			}
		},
		mounted() {
		},
		methods: {

		}
	}
</script>
